import React, { useState, useEffect } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import "./contact.css";
import { trackPortfolioVisit, trackContactEngagement } from "../../utils/analytics";


function Contact() {
  const [recaptchaValue, setRecaptchaValue] = useState(null);

  useEffect(() => {
    // Track when Contact section is loaded
    trackPortfolioVisit('contact');
  }, []);

  const handleFormSubmit = (event) => {
    event.preventDefault();
    
    // Check if reCAPTCHA is completed
    if (!recaptchaValue) {
      trackContactEngagement('recaptcha_required');
      window.alert("Please complete the reCAPTCHA verification.");
      return;
    }

    trackContactEngagement('form_submit_attempt');
    
    // Prepare form data
    const formData = new FormData(event.target);
    
    // Send to Formspree
    fetch("https://formspree.io/f/xreaqbke", {
      method: "POST",
      body: formData,
      headers: {
        Accept: "application/json",
      },
    })
      .then((response) => {
        if (response.ok) {
          // Track successful form submission
          trackContactEngagement('form_submit_success');
          
          // Displays alertbox on success
          window.alert("Form submitted successfully!");

          // Reset the form
          event.target.reset();
          
          // Reset reCAPTCHA
          setRecaptchaValue(null);
        } else {
          // Track form submission error
          trackContactEngagement('form_submit_error');
          window.alert("Form submission failed. Please try again later.");
        }
      })
      .catch((error) => {
        // Track form submission error
        trackContactEngagement('form_submit_error');
        window.alert("Form submission failed. Please try again later.");
        console.log("FAILED...", error);
      });
  };

  return (
    <div>
      <div className="center">
        <section id="contact">
          <h1 className="heading">
            <span className="text autoplay"> CONTACT ME </span>
          </h1>
        </section>
      </div>

      <br />
      <br />

      {/* Form + picture */}
      <div className="center">
        <div className="form-container">
          <div className="form-image">
            <img
              src="/images/contact_me_2.png"
              alt="Contact form illustration"
            />
          </div>

          <form className="form" onSubmit={handleFormSubmit}>
            <div className="input-group">
              <label htmlFor="username">Name and Surname</label>
              <input
                type="text"
                name="username"
                id="username"
                maxLength="30"
                required
              />
            </div>

            <br />

            <div className="input-group">
              <label htmlFor="email">Email address</label>
              <input
                type="email"
                name="email"
                id="email"
                maxLength="50"
                required
              />
            </div>

            <br />

            <div className="input-group">
              <label htmlFor="submit">Subject line</label>
              <input
                type="text"
                name="subject"
                id="subject"
                maxLength="50"
                required
              />
            </div>

            <br />

            <div className="input-group">
              <label htmlFor="text">Message</label>
              <textarea
                id="message"
                name="message"
                maxLength="250"
                rows="8"
                required
                placeholder="Max of 250 characters"
              />
            </div>

            <br />
            <br />

            {/* reCAPTCHA */}
            <div className="reCAPTCHA">
              <ReCAPTCHA
                sitekey="6LcYobIqAAAAAPxuiF5Zzh7wCOvjl8E1vz0gD5qc"
                onChange={(value) => {
                  setRecaptchaValue(value);
                }}
                onExpired={() => setRecaptchaValue(null)}
                required
              />
            </div>

            {/* submit and reset buttons below */}
            <button type="submit" className="submit">
              SUBMIT
            </button>
            <br />
            <input type="reset" className="clear" value="RESET" onClick={() => setRecaptchaValue(null)} />
          </form>
        </div>
      </div>

      <div className="footer">
        <br></br>
        <br></br>
        <br></br>
        <b>© 2024 - 2026 Lusaduma Mata's Portfolio</b> 
        <br></br>
        <b> Last updated: October 2026</b>
      </div>
    </div>
  );
}

export default Contact;
